import React from "react";
import moment from "moment";
import { FaPlus } from "react-icons/fa";

function CommissionInvoiceExpectedPaymentCell({
  invoice,
  disabled = false,
  onStartEdit,
}) {
  const expectedDate =
    invoice?.expectedPaymentDate || invoice?.expected_payment_date || null;
  const hasData = Boolean(expectedDate);

  if (!hasData) {
    return (
      <button
        type="button"
        className="cms-invoice-expected-payment-cell__add"
        onClick={onStartEdit}
        disabled={disabled}
        title="Add expected payment date and note"
        aria-label="Add expected payment date and note"
      >
        <FaPlus size={10} aria-hidden />
      </button>
    );
  }

  const formattedDate = moment(expectedDate).isValid()
    ? moment(expectedDate).format("MMM D, YYYY")
    : expectedDate;

  return (
    <button
      type="button"
      className="cms-invoice-expected-payment-cell__date"
      onClick={onStartEdit}
      disabled={disabled}
      title="Edit expected payment date"
    >
      {formattedDate}
    </button>
  );
}

export default CommissionInvoiceExpectedPaymentCell;
